import { SubStore } from 'store/types';

export interface MetricItem {
  dataType: string;
  description: string;
  name: string;
}

export type MetricType = 'index' | 'equity';

export interface MetricsStore extends SubStore {
  index: {
    [id: string]: MetricItem[];
  };
  equity: {
    [id: string]: MetricItem[];
  };
  selected: {
    [id: string]: string;
  };
  sanitized: {
    [id: string]: Array<{ name: string; dataType: string }>;
  };
}

const metricsStore: MetricsStore = {
  index: {},
  equity: {},
  selected: {},
  sanitized: {},
  status: 'init',
};

export { metricsStore };
